import { render } from "./MDataTableEmpty.vue?vue&type=template&id=3b9ded1e"
import script from "./MDataTableEmpty.vue?vue&type=script&lang=js"
export * from "./MDataTableEmpty.vue?vue&type=script&lang=js"

import "./MDataTableEmpty.vue?vue&type=style&index=0&id=3b9ded1e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__